import React from 'react';

/**
 * Bootstrap-styled confirmation modal — replaces window.confirm().
 * Props:
 *   show: bool
 *   title: string
 *   message: string (or JSX)
 *   confirmLabel: string (default 'Confirm')
 *   cancelLabel: string (default 'Cancel')
 *   hideCancel: bool — show only the confirm button (for plain notices)
 *   variant: 'danger' | 'warning' | 'primary' (default 'danger')
 *   onConfirm: () => void
 *   onCancel: () => void
 */
export default function ConfirmModal({
  show,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  hideCancel = false,
  variant = 'danger',
  onConfirm,
  onCancel,
}) {
  if (!show) return null;
  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1070 }} onClick={onCancel} />
      <div className="modal fade show d-block" style={{ zIndex: 1080 }} tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 420 }}>
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title">{title}</h5>
              <button className="btn-close" onClick={onCancel} />
            </div>
            <div className="modal-body pt-2" style={{ fontSize: 14 }}>
              {message}
            </div>
            <div className="modal-footer border-0 pt-0">
              {!hideCancel && <button className="btn btn-outline-secondary btn-sm" onClick={onCancel}>{cancelLabel}</button>}
              <button className={`btn btn-${variant} btn-sm`} onClick={onConfirm}>{confirmLabel}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
